// extracted by mini-css-extract-plugin
export default {"genbutton":"GenButton_genbutton__13xOT","preicon":"GenButton_preicon__Fgy63","posticon":"GenButton_posticon__NH5-9"};